import createDomNode from '../functions/createDomNode';
import { config } from '../config/config';
import translations from '../config/translations';
import createMarkupDiv from './createMarkupDiv';

export default () => {
    const backdrop = document.createElement('div');
    backdrop.className = 'cookie-consent-backdrop';

    const modal = createDomNode('div', 'cookie-consent-modal');

    const headline = createDomNode('h5', 'cookie-consent-headline', translations.headlineText);
    const paragraph = createDomNode('p', 'cookie-consent-paragraph', translations.sublineText);
    const buttonContainer = createDomNode('div', 'cookie-consent-button-container');

    const submitButton = createDomNode('button', 'cookie-consent-button');
    const submitButtonText = createDomNode('span', 'cookie-consent-button-text');
    const loadingSubmitIcon = createDomNode('div', 'loading-icon');

    submitButtonText.innerText = translations.submitButtonText;
    submitButton.innerHTML = submitButtonText.outerHTML;
    submitButton.innerHTML += loadingSubmitIcon.outerHTML;
    submitButton.id = 'cookie-consent-submit-button';
    buttonContainer.innerHTML += submitButton.outerHTML;

    const submitAllButton = createDomNode('button', 'cookie-consent-button');
    const submitAllButtonText = createDomNode('span', 'cookie-consent-button-text');
    const loadingSubmitAllIcon = createDomNode('div', 'loading-icon');

    submitAllButtonText.innerText = translations.submitAllButtonText;
    submitAllButton.innerHTML = submitAllButtonText.outerHTML;
    submitAllButton.innerHTML += loadingSubmitAllIcon.outerHTML;
    submitAllButton.id = 'cookie-consent-submit-all-button';
    buttonContainer.innerHTML += submitAllButton.outerHTML;

    const inputContainer = createDomNode('div', 'cookie-consent-input-container');
    const inputFirstLineWrapper = createDomNode('div', 'cookie-consent-input-first-line-wrapper');
    const selectContainer = createDomNode('div', 'cookie-consent-select-container');

    // Create content for availableConsentTypes from config
    const newWrapperElements = [];
    const newInfoElements = [];

    for (let i = 0; i < config.availableConsentTypes.length; i += 1) {
        const consentType = config.availableConsentTypes[i];
        newWrapperElements.push(createMarkupDiv(consentType));

        newInfoElements.push(`<div class="cookie-consent-more-info-content" 
                    id="cookie-consent-more-info-statistics"><h5>${translations.consentTypes[consentType].title}</h5>
                    <p>${translations.consentTypes[consentType].text}</p></div>`);
    }

    const moreInfoTriggerContainer = createDomNode('div', 'cookie-consent-more-info-trigger-container');
    const moreInfoTrigger = createDomNode('span', 'cookie-consent-more-info-trigger');

    const svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">'
        + '<path d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z '
        + 'M12,20.9c-4.9,0-8.9-4-8.9-8.9s4-8.9,8.9-8.9s8.9,4,8.9,8.9 S16.9,20.9,12,20.9z '
        + 'M13.1,17h-2v-6h2V17z M13.1,9h-2V7h2V9z M13.1,17h-2v-6h2V17z M13.1,9h-2V7h2V9z"/></svg>';
    moreInfoTrigger.innerHTML = `${svgIcon} <span class="cookie-consent-more-info-trigger-text">
                                            ${translations.showDetailsText}</span>`;
    moreInfoTrigger.id = 'cookie-consent-more-info-trigger';
    moreInfoTriggerContainer.innerHTML = moreInfoTrigger.outerHTML;


    const moreInfoContainer = createDomNode('div', 'cookie-consent-more-info-container');
    moreInfoContainer.id = 'cookie-consent-more-info-container';

    const moreInfoLink = `<div class="cookie-consent-more-info-content
        cookie-consent-more-info-content-link-line">${translations.moreInfoPreText} 
        <a target="_blank" href="${translations.cookieConsentHref}">${translations.moreInfoLinkText}</a></div>`;

    for (let i = 0; i < newWrapperElements.length; i += 1) {
        selectContainer.innerHTML += newWrapperElements[i].outerHTML;
    }

    for (let i = 0; i < newInfoElements.length; i += 1) {
        moreInfoContainer.innerHTML += newInfoElements[i];
    }
    moreInfoContainer.innerHTML += moreInfoLink;

    inputFirstLineWrapper.innerHTML = selectContainer.outerHTML;
    inputFirstLineWrapper.innerHTML += moreInfoTriggerContainer.outerHTML;

    inputContainer.innerHTML += inputFirstLineWrapper.outerHTML;
    inputContainer.innerHTML += moreInfoContainer.outerHTML;

    modal.innerHTML += headline.outerHTML;
    modal.innerHTML += paragraph.outerHTML;
    modal.innerHTML += inputContainer.outerHTML;
    modal.innerHTML += buttonContainer.outerHTML;

    backdrop.innerHTML = modal.outerHTML;

    return backdrop;
};
